module.exports = __webpack_public_path__ + "media/Kavinsky - Nightcall.abed18a8.mp3";